var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApplicantUnsubscribed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 21049"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 21048"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 34",
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#235594"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 43604"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 13.3857V22.4305L15.3111 17.9085L10 13.3857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.6601 20.6128C23.2404 20.0496 23.991 19.703 24.7933 19.6277V13.3857L19.4824 17.9085L22.6601 20.6128Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.0369 17.6561L17.3965 18.8141L18.7561 17.6561L18.7589 17.6543L24.2246 13H10.5684L16.034 17.6543L16.0369 17.6561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M25.1243 20.272C24.2831 20.272 23.4854 20.64 22.9359 21.2814C22.9359 21.2816 22.9354 21.282 22.9352 21.2823C22.9348 21.2827 22.9343 21.2829 22.9339 21.2836C22.4923 21.8033 22.249 22.4652 22.249 23.1474C22.249 24.7329 23.5391 26.0227 25.1243 26.0227C26.7095 26.0227 27.9997 24.7326 27.9997 23.1474C27.9997 21.5622 26.7097 20.272 25.1243 20.272ZM26.3311 24.354C26.2019 24.4832 25.9922 24.4832 25.8628 24.354L25.1243 23.6155L24.386 24.354C24.2566 24.4832 24.0468 24.4832 23.9177 24.354C23.7883 24.2246 23.7883 24.0149 23.9177 23.8857L24.656 23.1472L23.9177 22.4089C23.7885 22.2798 23.7885 22.07 23.9177 21.9406C24.0471 21.8113 24.2568 21.8113 24.3862 21.9406L25.1243 22.6789L25.8626 21.9406C25.9919 21.8113 26.2017 21.8113 26.3308 21.9406C26.4602 22.07 26.4602 22.2798 26.3308 22.4089L25.5928 23.1472L26.3311 23.8857C26.4604 24.0149 26.4604 24.2246 26.3311 24.354Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M17.6113 19.502C17.5495 19.5547 17.4731 19.581 17.3965 19.581C17.3199 19.581 17.2437 19.5545 17.1817 19.502L15.8214 18.3438L10.5684 22.8163H21.603C21.6607 22.2054 21.8764 21.619 22.2287 21.1161L18.9715 18.3438L17.6113 19.502Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicantUnsubscribed);
export default __webpack_public_path__ + "static/media/applicantUnsubscribed.cee7eb1b622fa4eb5eaa0a4ef8ad716d.svg";
export { ForwardRef as ReactComponent };